import { Head, Link } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import type { Breadcrumb } from '@/types/shared'

type SchoolSummary = {
  id: string
  name: string
  prefecture?: string | null
  createdAt: string
}

type AdminSchoolsIndexProps = {
  schools: SchoolSummary[]
  breadcrumbs: Breadcrumb[]
}

export default function AdminSchoolsIndex({ schools, breadcrumbs }: AdminSchoolsIndexProps) {
  return (
    <AppShell>
      <Head title="高校一覧" />
      <PageHeader
        title="高校一覧"
        description="登録済みの高校マスターを管理します。"
        breadcrumbs={breadcrumbs}
        actions={
          <Button asChild size="sm">
            <Link href="/admin/schools/new">新規高校登録</Link>
          </Button>
        }
      />

      <Card padding="none" className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-white/5 text-sm text-white/80">
            <thead className="bg-white/5 text-xs uppercase tracking-wide text-white/60">
              <tr>
                <th className="px-6 py-4 text-left font-semibold">高校名</th>
                <th className="px-6 py-4 text-left font-semibold">都道府県</th>
                <th className="px-6 py-4 text-left font-semibold">登録日</th>
                <th className="px-6 py-4" />
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {schools.map((school) => (
                <tr key={school.id} className="hover:bg-white/5 transition">
                  <td className="px-6 py-4 font-medium text-white">{school.name}</td>
                  <td className="px-6 py-4 text-white/70">{school.prefecture ?? '未設定'}</td>
                  <td className="px-6 py-4 text-white/60">{formatDate(school.createdAt)}</td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex justify-end gap-4 text-sm">
                      <Link href={`/admin/schools/${school.id}`} className="text-brand-200 hover:text-brand-100">
                        詳細
                      </Link>
                      <Link href={`/admin/schools/${school.id}/edit`} className="text-brand-200 hover:text-brand-100">
                        編集
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {schools.length === 0 ? (
          <div className="px-6 py-16 text-center text-sm text-white/50">登録されている高校はありません。</div>
        ) : null}
      </Card>
    </AppShell>
  )
}

function formatDate(value: string) {
  return new Date(value).toLocaleDateString('ja-JP')
}
